import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { usePrevious } from "react-use";

import { Input } from "adminComponents/atoms/Input";
import { Modal } from "adminComponents/atoms/Modal";
import { pxToRem } from "adminComponents/utils";
import { ConfirmButton } from "sessionComponents/molecules/ConfirmButton";

interface IEmailAvatarModalProps {
  handleEmailAvatar: (email: string) => void;
  isOpen: boolean;
  onClose: () => void;
}

const basicEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EmailAvatarModal: React.FC<IEmailAvatarModalProps> = ({
  handleEmailAvatar,
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation("admin", {
    useSuspense: false,
  });
  const [email, setEmail] = useState<string>();
  const [isValid, setIsValid] = useState<boolean>(false);
  const isOpenPrev = usePrevious(isOpen);

  useEffect(() => {
    if (basicEmailRegex.test(email || "")) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [email]);

  useEffect(() => {
    if (isOpen && !isOpenPrev) {
      setEmail(undefined);
    }
  }, [isOpen, isOpenPrev]);

  return (
    <Modal
      title={t("teacherMyAvatarContainer.emailHeading")}
      isOpen={isOpen}
      onClose={onClose}
      showBackButton={false}
    >
      <Input
        value={email}
        placeholder="Enter email"
        onChange={(e) => {
          e.preventDefault();
          setEmail(e.target.value);
        }}
      />
      <ConfirmButton
        variant="buttonFilled"
        onClick={() => {
          handleEmailAvatar(email || "");
          onClose();
        }}
        disabled={!isValid}
        marginTop={pxToRem(16)}
        confirmedWhenChanged={[]}
      >
        {t("common.send")}
      </ConfirmButton>
    </Modal>
  );
};
